jQuery(document).ready(function ($) {
    $('.autoreferrer-link').each(function () {

        const handleAutoref = function ($link) {
            //console.log(encodeURI($link.attr("href")))
            //console.log($link)
            window.location = encodeURI($link.attr("href"))
        };

        handleAutoref($(this));
    })
})